module.exports = __webpack_public_path__ + "img/模版@3x.59626536.png";